import { getStoreId } from "$/hooks/use-store-information"
import customBookingSectionQueries from "$/lib/queries/custom-booking-section-queries"
import feeQueries from "$/lib/queries/fee-queries"
import jobQueries from "$/lib/queries/job-queries"
import { newReceptionDataForBookingQueryOptions } from "$/lib/queries/reception-queries"
import servicePackageQueries from "$/lib/queries/service-package-queries"
import serviceSettingsQueries from "$/lib/queries/service-settings-queries"
import storeQueries from "$/lib/queries/store-queries"
import washQueries from "$/lib/queries/wash-queries"
import { JobStatus } from "@repo/common"
import { QueryClient } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { z } from "zod"

const searchSchema = z.object({
  eventId: z.string().uuid().optional(),
  customerName: z.string().optional(),
})

export const Route = createFileRoute("/(app)/_auth/jobs/$jobId/new-reception")({
  validateSearch: zodValidator(searchSchema),
  loader: async ({ context: { queryClient }, params: { jobId } }) => {
    const job = await queryClient.fetchQuery(jobQueries.detail(jobId))

    if (
      job.status !== JobStatus.BOOKED &&
      job.status !== JobStatus.CHECKED_IN
    ) {
      throw redirect({ to: "/jobs/$jobId", params: { jobId } })
    }

    const storeId = await getStoreId()

    if (storeId) prefetch(queryClient, storeId, jobId)

    return {
      crumb: "alfred.jobs.reception.crumb",
    }
  },
})

function prefetch(queryClient: QueryClient, storeId: string, jobId: string) {
  queryClient.prefetchQuery(
    newReceptionDataForBookingQueryOptions(storeId, jobId),
  )
  queryClient.prefetchQuery(servicePackageQueries.list({ storeId }))
  queryClient.prefetchQuery(washQueries.list({ storeId }))
  queryClient.prefetchQuery(feeQueries.list({ storeId }))
  queryClient.prefetchQuery(storeQueries.detail(storeId))
  queryClient.prefetchQuery(customBookingSectionQueries.list({ storeId }))
  queryClient.prefetchQuery(serviceSettingsQueries.detail(storeId))
}
